/** نمایش و ناوبری آیتم‌های پیگیری / فعالیت */

import moment from 'moment-jalaali';

export const resolveFollowUpRelatedType = (item) => {
  if (!item) return { type: null, label: '—' };
  if (item.deal_id) return { type: 'deal', label: 'معامله' };
  if (item.lead_id ?? item.leads?.id) return { type: 'lead', label: 'سرنخ' };
  return { type: null, label: '—' };
};

export const resolveFollowUpMobile = (item) => {
  if (!item) return '—';

  if (item.deal_id) {
    const deal = item.lead || item.deal;
    const mobile =
      deal?.mobile ||
      deal?.contact?.mobile ||
      deal?.client?.mobile ||
      item.mobile;
    return mobile || '—';
  }

  const lead = item.leads || item.lead;
  const mobile = lead?.mobile || lead?.cell || item.mobile;
  return mobile || '—';
};

export const resolveFollowUpEntity = (item) => {
  if (!item) return { type: null, id: null, name: '—', href: null };

  if (item.deal_id) {
    const deal = item.lead || item.deal;
    const dealName =
      deal?.name
      || deal?.client_name
      || item.client_name
      || item.company_name
      || `معامله #${item.deal_id}`;
    const clientName =
      deal?.client?.name
      || item.client?.name
      || item.customer?.name;
    const name = clientName ? `${dealName} - ${clientName}` : dealName;
    return {
      type: 'deal',
      id: item.deal_id,
      name,
      href: `/deals/${item.deal_id}?tab=follow-up`,
    };
  }

  const leadId = item.lead_id ?? item.leads?.id;
  if (leadId) {
    const lead = item.leads || item.lead;
    return {
      type: 'lead',
      id: leadId,
      name: lead?.client_name || lead?.name || `سرنخ #${leadId}`,
      href: `/leads/${leadId}?tab=follow-up`,
    };
  }

  return { type: null, id: null, name: '—', href: null };
};

export const followUpStatusLabel = (status) => {
  if (status === 'completed') return 'انجام‌شده';
  if (status === 'canceled' || status === 'cancelled') return 'لغو شده';
  if (status === 'pending') return 'در انتظار';
  return status || '—';
};

export const formatFollowUpDate = (value) => {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('fa-IR');
  } catch {
    return String(value);
  }
};

/** تاریخ فعالیت با برچسب امروز/دیروز در صورت نیاز */
export const formatFollowUpDateWithRelative = (value) => {
  if (!value) return { main: '—', relative: null };
  try {
    const m = moment(value);
    if (!m.isValid()) return { main: String(value), relative: null };
    const main = m.format('jYYYY/jMM/jDD HH:mm');
    const diff = m.clone().startOf('day').diff(moment().startOf('day'), 'days');
    let relative = null;
    if (diff === 0) relative = 'امروز';
    else if (diff === -1) relative = 'دیروز';
    return { main, relative };
  } catch {
    return { main: String(value), relative: null };
  }
};

/** مسیر مشاهده فعالیت در تب پیگیری سرنخ/معامله */
export const resolveFollowUpActivityHref = (item) => {
  const entity = resolveFollowUpEntity(item);
  if (!entity.href || !item?.id) return entity.href;
  const sep = entity.href.includes('?') ? '&' : '?';
  return `${entity.href}${sep}follow_up_id=${item.id}`;
};

export const FOLLOW_UPS_LIST_PATH = '/dashboard/follow-ups';
export const FOLLOW_UPS_LIST_RETURN_STORAGE_KEY = 'crm:follow-ups-list-return';

export const buildPendingFollowUpsListPath = (userId) => {
  const params = new URLSearchParams();
  params.set('status', 'pending');
  if (userId) params.set('assign_to', String(userId));
  return `${FOLLOW_UPS_LIST_PATH}?${params.toString()}`;
};
